import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { closeModal } from 'modal/store/actions';
import MainTitle from 'base/components/MainTitle';
import {
  createDefaultDashboard,
  getMinimalDashboard,
} from '../../../../dashboard';
import DefaultDashboardForm from './DefaultDashboardForm';

const NarrowWrapper = styled.div`
  width: 700px;
  margin: 0 auto;
`;


const EditDefaultDashboard = ({
  dashboard,
  createDefaultDashboard,
  closeModal,
  name,
}) => (
  <>

    <NarrowWrapper>
      <MainTitle withSpaceBelow>Create default dashboard</MainTitle>
    </NarrowWrapper>

    <DefaultDashboardForm
      dashboard={dashboard}
      onSubmit={(dashboard) => {
        createDefaultDashboard(dashboard);
        closeModal(name);
      }}
    />

  </>

);
EditDefaultDashboard.propTypes = {
  dashboard: PropTypes.objectOf(PropTypes.any).isRequired,
  createDefaultDashboard: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  dashboard: getMinimalDashboard(state),
});

const mapDispatchToProps = {
  createDefaultDashboard,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditDefaultDashboard);
